import { render, staticRenderFns } from "./Zaius.vue?vue&type=template&id=501c2b3f"
import script from "./Zaius.vue?vue&type=script&lang=js"
export * from "./Zaius.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports